module.exports = __webpack_public_path__ + "static/media/prince2.9bcd6110.png";